/* eslint-disable import/prefer-default-export */
import * as types from "./actionTypes";

export const updateDetailsStoreDate = () => ({
  type: types.UPDATE_DETAILS_STORE_DATE,
});

export const test3Prompt = () => ({
  type: types.TEST_3_MONTH_PROMPT,
});
